import { render, staticRenderFns } from "./EditDatabaseAccess.vue?vue&type=template&id=2d75f000&scoped=true&"
import script from "./EditDatabaseAccess.vue?vue&type=script&lang=js&"
export * from "./EditDatabaseAccess.vue?vue&type=script&lang=js&"
import style0 from "./EditDatabaseAccess.vue?vue&type=style&index=0&id=2d75f000&prod&scoped=true&lang=css&"
import style1 from "./EditDatabaseAccess.vue?vue&type=style&index=1&id=2d75f000&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75f000",
  null
  
)

export default component.exports